// key to store user selected site-options in local-storage
export const SELECTED_OPTIONS_KEY = "selectedSiteOptionsInBatchLB";
export const IS_DETAILED_VIEW_KEY = "isDetailedViewSelected";

// key to store user settings in local-storage
export const IS_CRAWLER_APPROVED_KEY = "isCrawlerApproved";